import * as types from '../const/action.types';

export default (state = 0, action) => {
    switch (action.type) {
        case types.SET_ALERT_TAB:
            return action.value;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/alert.tabs.reducer.js